export const WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION = 8;
